import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Alert } from '@mui/material';

const COLORS = {
  success: '#1E9E29',
  error: '#DF374B',
  warning: '#757575',
};

const AUTO_DISMISS_MS = 5000;

const PaymentBanner = ({ severity, message, onClose }) => {
  const isSuccess = severity === 'success';

  useEffect(() => {
    if (!isSuccess) return;
    const timer = setTimeout(onClose, AUTO_DISMISS_MS);
    return () => clearTimeout(timer);
  }, [isSuccess, onClose]);

  return (
    <Alert
      severity={severity}
      onClose={isSuccess ? undefined : onClose}
      data-cy="payment-banner"
      sx={{
        backgroundColor: COLORS[severity],
        color: 'white',
        borderRadius: '4px',
        maxWidth: '452px',
        height: '35px',
        alignItems: 'center',
        py: 0,
        px: 2,
        '& .MuiAlert-icon': { color: 'white', mr: 1, py: 0 },
        '& .MuiAlert-message': { fontWeight: 700, fontSize: '14px', py: 0 },
        '& .MuiAlert-action': { color: 'white', py: 0, alignItems: 'center' },
      }}
    >
      {message}
    </Alert>
  );
};

PaymentBanner.propTypes = {
  severity: PropTypes.oneOf(['success', 'error', 'warning']).isRequired,
  message: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default PaymentBanner;
